

//const HOST_NAME = 'localhost';
//export const SERVER_HOST_URL = `http://${HOST_NAME}:3006`;

export const SERVER_HOST_URL = process.env.NODE_ENV === 'development' 
                                ? 'http://localhost:3006'
                                : 'https://quizapi.avinton.com'



/* Server */
export const LOGIN_URL = SERVER_HOST_URL + '/login'
export const LOGOUT_URL = SERVER_HOST_URL + '/logout'
export const RESULT_URL = SERVER_HOST_URL + '/result'
export const USER_INFO_URL = SERVER_HOST_URL + '/userinfo'
export const VALIDATION_URL = SERVER_HOST_URL + '/validation'
export const QUIZ_START_URL = SERVER_HOST_URL + '/startquiz'
export const TIME_LIMIT_URL = SERVER_HOST_URL + '/timelimit'



// WEBPACK FOOTER //
// ./src/client_url_constant.js